import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config'
import axios from 'axios'
import { Button, DatePicker, Divider, Modal, Table } from 'antd'
import { toast } from 'react-toastify'
import { ErrorToast, SuccessToast } from '../../views/ToastComponent'


function GarageAutoSingleUser() {
    const { id } = useParams()

    const location = useLocation();
    const { state } = location;
    const { workingDays, name, profitMarginName, income, liveVisitIncome, created } = state || {};

    const [singleData, setSingleData] = useState([])
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [observationModal, setObservationModal] = useState(false)
    const [EditDataId, setEditDataId] = useState(0); // initial will 0 
    const [geoLocationData, setGeoLocationData] = useState({ latitude: null, longitude: null });

    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/AutoGarage/getservicesbygarageid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSingleData(response.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])

    const [garageAutoData, setGarageAutoData] = useState({
        autoGarageId: id,
        service: '',
        tat: 0,
        orderQuantity: 0,
        orderQuantityPerDay: 0,
        amount: 0,
        totalAmount: 0,
        latitude: '',
        longitude: '',
        workingDays: workingDays
    })


    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setGarageAutoData({ ...garageAutoData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])


    const calculateMonthlyRevenue = () => {

        const result = garageAutoData.orderQuantity / workingDays
        setGarageAutoData(prev => ({
            ...prev,
            orderQuantityPerDay: result
        }))
    };

    const calculatePerMonth = () => {
        const result = garageAutoData.amount * garageAutoData.orderQuantity
        setGarageAutoData(prev => ({
            ...prev,
            totalAmount: Math.round(result / 30) || 0
        }))
    };



    React.useEffect(() => {
        calculateMonthlyRevenue();
    }, [garageAutoData.orderQuantity, garageAutoData.workingDays]);

    React.useEffect(() => {
        calculatePerMonth();
    }, [garageAutoData.amount, garageAutoData.orderQuantity]);



    const handleClick = async (id) => {

        setEditDataId(id)
        setIsModalOpen(true)

    }

    //update Method
    const handleSubmit = async (operationType) => {

        try {

            let response;
            if (operationType == "Submit") {
                response = await axios.post(`${Api_Url}api/v1/AutoGarage/add-service`, garageAutoData, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                    }
                })
                if (response.data?.succeeded) {
                    SuccessToast("Created Successfully")
                    handleCancel()
                    getSingleUser()
                }
            } else {
                const data = {
                    ...garageAutoData,
                    id: EditDataId
                }
                response = await axios.post(`${Api_Url}api/v1/AutoGarage/update-service`, data, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                    }
                })
                if (response.data?.succeeded) {
                    SuccessToast("Created Successfully")
                    handleCancel()
                    getSingleUser()
                }
            }
           

        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }

    async function handleCancel() {
        setGarageAutoData({
            ...garageAutoData,
            autoGarageId: id,
            service: '',
            tat: 0,
            orderQuantity: 0,
            orderQuantityPerDay: 0,
            amount: 0,
            totalAmount: 0,
            workingDays: workingDays
        })

        setEditDataId(0); // reset form with initial value 0
        setIsModalOpen(false);
    }

    async function LoadSingleAutogarage(hereId) {
        try {
            const response = await axios.get(`${Api_Url}api/v1/AutoGarage/getservicebyid/${hereId}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setGarageAutoData({
                ...garageAutoData,
                service: response.data?.service,
                tat: response.data?.tat,
                orderQuantity: response.data?.orderQuantity,
                orderQuantityPerDay: response.data?.orderQuantityPerDay,
                amount: response.data?.amount,
                totalAmount: response.data?.totalAmount,
                workingDays: response.data?.workingDays,
            })
        } catch (e) {
            console.log("Load Single Auto Garage", e.message)
        }
    }

    useEffect(() => {
        if (EditDataId !== 0) {

            LoadSingleAutogarage(EditDataId)
        }
    }, [EditDataId !== 0])

    const columns = [
        {
            title: "Service",
            dataIndex: "service",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
        },
        {
            title: "TAT",
            dataIndex: "tat",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Monthly order",
            dataIndex: "orderQuantity",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Per Day order",
            dataIndex: "orderQuantityPerDay",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Amount Charged",
            dataIndex: "totalAmount",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Amount Charged",
            dataIndex: "amount",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        // onClick={() => handleEdit(record.key)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
    ];


    // ObserVation Function

    const [prepareSetData, setPrepareSetData] = useState([])
    const ObservationPrepareFunction = async () => {
        let response;
        try {
            response = await axios.get(`${Api_Url}api/v1/AutoGarage/dayvisit/preparelivevisitbyautogarageid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setPrepareSetData(response.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => { ObservationPrepareFunction() }, [])

    const [obserVationData, setObserVationData] = useState([])

    const ObservationLiveVisitFunction = async () => {
        let response;
        try {
            response = await axios.get(`${Api_Url}api/v1/AutoGarage/dayvisit/getallautogaragelivevisitbyautogarageid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setObserVationData(response.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => { ObservationLiveVisitFunction() }, [])
    // Dayvisit Data Post Function

    const [selectDate, setSelectDate] = useState(null)

    const [dayVisitData, setDayVisitData] = useState({
        autoGarageId: id,
        liveVisits: "",
        latitude: "",
        longitude: ""
    });

    const VisitDate = new Date(selectDate).toISOString(); // or any specific date you want

    // Add visit date to prepareSetData only once when the component mounts
    useEffect(() => {
        const updatedPrepareSetData = prepareSetData.map(item => ({
            ...item,
            visitDate: VisitDate,
        }));
        setPrepareSetData(updatedPrepareSetData);
    }, [selectDate]); // Empty dependency array ensures this runs only once

    // Get geolocation data
    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(position => {
                const { latitude, longitude } = position.coords;
                setGeoLocationData({ latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [prepareSetData]); // Empty dependency array ensures this runs only once

    // Update dayVisitData when both prepareSetData and geoLocationData are available
    useEffect(() => {
        if (geoLocationData.latitude && geoLocationData.longitude && prepareSetData.length > 0) {
            setDayVisitData({
                autoGarageId: id,
                latitude: geoLocationData.latitude,
                longitude: geoLocationData.longitude,
                liveVisits: prepareSetData,
            });
        }
    }, [geoLocationData, prepareSetData]); // Add id to dependencies if it's dynamic

    const handleObservationSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/AutoGarage/dayvisit`, dayVisitData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            });
            if (response.data.succeeded) {
                SuccessToast("Created Successfully")
                handleObserveCancel()
                ObservationLiveVisitFunction()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            console.error("There was an error!", error);
        }
    };



    //   Calculations

    function handleValueChange(text, index) {
        const updatedTransferValue = [...prepareSetData];
        const updatedItem = {
            ...updatedTransferValue[index],
            quantity: parseInt(text, 10) || 0,
        };
        updatedItem.totalAmount = updatedItem.amount * updatedItem.quantity; // Calculate total amount
        updatedTransferValue[index] = updatedItem;
        setPrepareSetData(updatedTransferValue);
    }


    const ObserVationTable = [
        {
            title: "Service",
            dataIndex: "serviceName",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Charge",
            dataIndex: "amount",
            sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Total Amount",
            dataIndex: "totalAmount",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Created At",
            dataIndex: "visitDate",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
    ];

    async function handleObserveCancel() {
        setDayVisitData({
            ...dayVisitData,
            autoGarageId: id,
            liveVisits: "",
        })
        setObservationModal(false);
    }




    return (

        <>
            <div className="page-wrapper">
                <div className="content container-fluid">

                    <nav>
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Services</button>
                            <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Observation</button>
                        </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                        <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">

                            {/* Services GarageAuto */}

                            <div className="row">
                                <div className="col-12 d-flex align-items-center justify-content-between">
                                    <h3 className="mb-0">Pd Observation</h3>
                                    <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Service</button>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12 mx-auto">
                                    <Table
                                        className="table-striped"
                                        style={{ overflowX: "auto" }}
                                        columns={columns}
                                        dataSource={singleData}
                                        rowKey={(record) => record.id}
                                    />
                                </div>
                            </div>

                            <Modal
                                title={<h4>{EditDataId == 0 ? "Add" : "Edit"} Auto garage</h4>}
                                open={isModalOpen}
                                onOk={() => setIsModalOpen(false)}
                                onCancel={() => handleCancel()}
                                // closable={false}
                                footer={[
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleSubmit(EditDataId == 0 ? "Submit" : "Edit")}>{EditDataId == 0 ? "Submit" : "Update"}</button>
                                    </div>
                                ]}
                                width={600}
                                mask={false}
                                maskClosable={false}
                                closeIcon={<span style={{ color: 'red' }}>X</span>}
                            >
                                <div className="modal-body mt-5">
                                    <form>
                                        <Divider>Create Service</Divider>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Name of Service:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Service Name" value={garageAutoData.service} onChange={(e) => setGarageAutoData({ ...garageAutoData, service: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        TAT:(In Day)
                                                    </label>
                                                    <input className="form-control" type="number" placeholder="TAT" value={garageAutoData.tat} onChange={(e) => setGarageAutoData({ ...garageAutoData, tat: e.target.value })} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Order Per Month:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Enter Daily Grind In kg" value={garageAutoData.orderQuantity} onChange={(e) => setGarageAutoData({ ...garageAutoData, orderQuantity: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Amount Charged:
                                                    </label>
                                                    <input className="form-control" type="number" placeholder="Enter Grind Price" value={garageAutoData.amount} onChange={(e) => setGarageAutoData({ ...garageAutoData, amount: e.target.value })} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row my-3">
                                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                                <p className="mb-0">Operative Day: </p>
                                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {workingDays}</span>
                                            </div>
                                        </div>

                                        <div className="row my-3">
                                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                                <p className="mb-0">Order Per Day : </p>
                                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {garageAutoData.orderQuantityPerDay.toFixed(2)}</span>
                                            </div>
                                        </div>

                                        <div className="row my-3">
                                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                                <p className="mb-0">Amount Per Day : </p>
                                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {garageAutoData.totalAmount.toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Modal>

                        </div>



                        {/* 2nd Tab */}
                        <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">

                            {/* Observation GarageAuto */}

                            <div className="row">
                                <div className="col-12 d-flex align-items-center justify-content-between">
                                    <h3 className="mb-0">Pd Observation</h3>
                                    <button className="btn btn-primary submit-btn mb-2" onClick={() => setObservationModal(true)}>Add Observation</button>
                                </div>
                            </div>

                            {/* Table */}
                            <div className="row mt-4">
                                <div className="col-12 mx-auto">
                                    <Table
                                        className="table-striped"
                                        style={{ overflowX: "auto" }}
                                        columns={ObserVationTable}
                                        dataSource={obserVationData}
                                        rowKey={(record) => record.id}
                                    />
                                </div>
                            </div>
                            <Modal
                                title={<h4>Add Auto Obeservation</h4>}
                                open={observationModal}
                                onOk={() => setObservationModal(false)}
                                // closable={false}
                                onCancel={() => handleObserveCancel()}
                                footer={[
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleObserveCancel}>Cancel</button>,
                                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleObservationSubmit}>Submit</button>
                                    </div>
                                ]}
                                width={600}
                                mask={false}
                                maskClosable={false}
                                closeIcon={<span style={{ color: 'red' }}>X</span>}
                            >
                                <div className="modal-body mt-5">
                                    <form>
                                        <Divider>Create Service</Divider>

                                        {/* <DatePicker style={{ width: '100%' }} value={selectDate} onChange={(e)=>setSelectDate(e)} /> */}

                                        <input type='date' value={selectDate} onChange={(e) => setSelectDate(e.target.value)} />

                                        <div className='container mt-5'>
                                            <div className='row'>
                                                {
                                                    prepareSetData && prepareSetData.map((prepareData, index) => {
                                                        return (
                                                            <div className='col-md-12 mt-2'>
                                                                <label className='text-success'>
                                                                    {prepareData.serviceName}
                                                                </label>

                                                                <br />
                                                                <div className='d-flex justify-content-between align-items-center'>
                                                                    <input
                                                                        type={prepareData.quantity}
                                                                        className='form-control mr-2'
                                                                        placeholder='Quantity'
                                                                        style={{ width: '150px' }}
                                                                        onChange={(e) => handleValueChange(e.target.value, index)}
                                                                    />
                                                                    <div>
                                                                        <label>Total Amount</label>
                                                                        <input
                                                                            type={prepareData.totalAmount}
                                                                            className='form-control'
                                                                            placeholder='Amount'
                                                                            style={{ width: '150px' }}
                                                                            value={prepareData.totalAmount}
                                                                        />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GarageAutoSingleUser


